const module = { name: 'video/placeholder', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { default as videoEvents } from 'swug-fdRequire-call:video/events';



import { default as videoIframe } from 'swug-fdRequire-call:video/iframe';



import { default as redbandVerification } from 'swug-fdRequire-call:video/redbandVerification';



const Selectors = {
    WRAP: '#vdlpVideoPlayerWrap',
    PLACEHOLDER: '.js-video-placeholder',
}
function removeBg(index, item) {
    const $target = $(item);
    const $img = $('img', $target);
    const src = `url(${$img.attr('src')})`;
    $target.attr('data-background-image', src).css('background-image', src);
    $img.remove();
}
function onComplete(ok) {
    if (ok) {
        injectIframe($(Selectors.WRAP + ' ' + Selectors.PLACEHOLDER));
    }
}
function onClick() {
    const $target = $(this);
    if ($target.data('mature') && !redbandVerification.ageOk()) {
        return redbandVerification.showAgeModal(onComplete);
    }
    injectIframe($target);
}
function injectIframe($target) {
    $target.css('background-image', 'none').removeClass('media-player__placeholder');
    const playerSrc = $target.data('iframe-url');
    const success = videoIframe.load(playerSrc, {
        autoplay: true
    });
    if (!success) {
        $target.text('Unable to play this video at this time');
    }
    const e = document.createEvent('CustomEvent');
    e.initCustomEvent(videoEvents.EventNames.PLACEHOLDER_CLICK, false, false, {
        playerSrc
    });
    window.dispatchEvent(e);
}
function init() {
    $(Selectors.WRAP).on('click', Selectors.PLACEHOLDER, onClick);
    $(Selectors.PLACEHOLDER).each(removeBg);
}
module.exports = {
    init
};
export default module.exports;